// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationLayout_container__Zn65Y","fullSizeContent":"NavigationLayout_fullSizeContent__k6X_u"};